<section role="alert" class="space-y-4">
  <h1 class="text-2xl font-bold">Access denied</h1>
  <p>This page requires a system administrator account.</p>
  <a href="#/" class="btn btn-primary">Return to overview</a>
</section>
